// extracted by mini-css-extract-plugin
module.exports = {"content":"grt-work-flow-submit--content--3lntPla","title":"grt-work-flow-submit--title--3uPf1Ty"};